export const SORT_ASCENDING = 'ASC';
export const SORT_DESCENDING = 'DESC';
export const DEFAULT_SORT_ORDER = SORT_ASCENDING;
export const COMPONENT_NAME = 'table';

export const DATA_UNDEFINED = '---';
